export default {
	"refund.ParameterError": "参数错误!",
	"refund.refundTime": "退款时间",
	"refund.growBeans": "成长豆",
	"refund.totalRefund": "退款总额",
	"refund.refundAmount": "退款金额"
}